// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 95 ? "a0381dde" : chunkId) + "." + {"95":"ede1f15265acbabc","775":"290d04ca6b01d981"}[chunkId] + ".js";
};